import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ZumoPoints from "@/pages/ZumoPoints";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  return (
    <div className="App min-h-screen" style={{ background: '#FCF8F6' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/zumo-points" element={<ZumoPoints />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
